import { getAppPathname } from "@/Utils/routing/getAppPathname";

export type SuperOpsWidgetName = "Opportunities" | "Documents";

export const isAllowedSuperOpsRoute = (): boolean => {
	const pathname = getAppPathname();

	const allowedPaths = ["/opportunities", "/documents"];

	return allowedPaths.some(path => {
		return pathname === path || pathname.startsWith(path + "/");
	});
};

const startsWithRoute = (pathname: string, route: string): boolean =>
	pathname === route || pathname.startsWith(route + "/");

export const resolveSuperOpsWidgetName = (
	pathname: string = getAppPathname()
): SuperOpsWidgetName | null => {
	if (startsWithRoute(pathname, "/opportunities")) {
		return "Opportunities";
	}
	if (
		startsWithRoute(pathname, "/documents") ||
		startsWithRoute(pathname, "/templates")
	) {
		return "Documents";
	}
	return null;
};
